import React from 'react';
import PropTypes from 'prop-types';

import Image from 'components/image';
import Text from 'components/text';

const SellingPoints = ({ items }) => (
  <div className="selling-points">
    {items.map(({ image, text, url } = {}) => {
      const Element = url ? 'a' : 'div';

      return (
        <Element className="selling-points-item" href={url} key={text}>
          <div className="selling-points-icon">
            <Image responsive={false} {...image} />
          </div>
          <Text.div className="selling-points-text" theme={Text.themes.small}>
            {text}
          </Text.div>
        </Element>
      );
    })}
  </div>
);

SellingPoints.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.exact({
      image: PropTypes.exact(Image.propTypes),
      text: PropTypes.string,
      url: PropTypes.string
    })
  )
};

SellingPoints.defaultProps = {
  items: []
};

export default SellingPoints;
